import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { load } from 'redux-load-api';
import _ from 'lodash';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import store from './redux/store';
import { infoDismiss } from './redux/modules/info';
import { notifClearAll } from './redux/modules/notifs';
import { AuthProvider, makeRouterRedirects } from './components/Auth';
import App from './containers/App';
import Home from './containers/Home';
import InvoiceTable from './containers/InvoiceTable';
import NotFound from './containers/NotFound';
import { CacheAdmin } from './containers/CacheAdmin';
import './index.css';

// Enhanced history
const history = syncHistoryWithStore(browserHistory, store);

const { userAuth, prcoAdminAuth } = makeRouterRedirects();

const onRouteChange = () => {
  store.dispatch(infoDismiss());
  store.dispatch(notifClearAll());

  window.scrollTo(0, 0);
  if (_.isFunction(_.get(window, 'parent.postMessage'))) {
    window.parent.postMessage('SCROLL_TOP', '*');
  }
};

load([App]);

// TODO: Use dash case for routes
ReactDOM.render(
  <Provider store={store}>
    <AuthProvider>
      <Router history={history}>
        <Route path="/" component={App} onChange={onRouteChange}>
          <IndexRoute component={Home} />

          {/* Authenticated Routes */}
          <Route path="invoices" component={userAuth(InvoiceTable)} />

          {/* Admin Routes */}
          <Route path="admin/cache" component={prcoAdminAuth(CacheAdmin)} />

          {/* Catch all route */}
          <Route path="*" component={NotFound} status={404} />
        </Route>
      </Router>
    </AuthProvider>
  </Provider>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js